import React from 'react';
import styled from 'styled-components';

type Props = {
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  locales?: string | string[];
  options?: Intl.NumberFormatOptions;
  value: number;
};

const Root = styled.span.attrs({
  // Numbers are LTR in some RTL languages. For example, prefer "-13.37%" over "13.37%-".
  dir: 'ltr',
})``;

const LocalizedNumber = ({ as, locales, options, value }: Props) => {
  return <Root as={as}>{value.toLocaleString(locales, options)}</Root>;
};

export default LocalizedNumber;
